import React from "react";

import { cn } from "@/lib/utils";

function normalizeCountryCode(value) {
  return String(value || "").trim().toUpperCase();
}

function countryCodeToEmoji(code) {
  const normalized = normalizeCountryCode(code);
  if (!/^[A-Z]{2}$/.test(normalized)) return "";
  return normalized.replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
}

export default function RiderFlag({
  countryCode,
  className = "",
  imgClassName = "",
  fallbackClassName = "",
  alt = "",
}) {
  const code = normalizeCountryCode(countryCode);
  const [hasAssetError, setHasAssetError] = React.useState(false);

  React.useEffect(() => {
    setHasAssetError(false);
  }, [code]);

  if (!code) return null;

  const fallbackEmoji = countryCodeToEmoji(code);
  const src = `/flags/nucleo/${code.toLowerCase()}.svg`;
  const label = alt || `Flagga ${code}`;

  return (
    <span
      className={cn("inline-flex items-center justify-start", className)}
      title={code}
      aria-label={label}
    >
      {!hasAssetError ? (
        <img
          src={src}
          alt={label}
          loading="lazy"
          className={cn("h-3.5 w-5 rounded-[2px] object-cover shadow-sm", imgClassName)}
          onError={() => setHasAssetError(true)}
        />
      ) : fallbackEmoji ? (
        <span className={cn("text-sm leading-none", fallbackClassName)} aria-hidden="true">
          {fallbackEmoji}
        </span>
      ) : (
        <span
          className={cn(
            "inline-flex h-3.5 min-w-[1.25rem] items-center justify-center rounded-[3px] border border-border bg-muted px-1 text-[9px] font-semibold uppercase leading-none text-muted-foreground",
            fallbackClassName
          )}
          aria-hidden="true"
        >
          {code}
        </span>
      )}
    </span>
  );
}
